module.exports = __webpack_public_path__ + "img/discord-button.b63b042b.svg";